import {makeStyles} from '@material-ui/core/styles'
import TableGridDiv from '../../2compounds/Tables/TableGridDiv'
import TableHeaderRow from '../../2compounds/Tables/TableHeaderRow'
import TableHeaderCell from '../../2compounds/Tables/TableHeaderCell'
import TableBody from '../../2compounds/Tables/TableBody'
import TableBodyRow from '../../2compounds/Tables/TableBodyRow'
import TableBodyCell from '../../2compounds/Tables/TableBodyCell'
import React from 'react'

const CommonErrorsTable = ({columnReferencePath}) => {
    const classes = useStyles()
    const columns = [
        {label: 'Error', position: 'span 3'},
        {label: 'Cause', position: 'span 5'},
        {label: 'Solution', position: 'span 4'},
    ]

    const resolveCommonErrors = [
        {
            error: 'File is empty',
            cause: 'Your file does not contain any information, or there are empty rows after the header.',
            solution: 'Enter information starting from row 2 (just below the header row)'
        },
        {
            error: 'Incorrect file format',
            cause: 'You have uploaded a file, not in CSV format.',
            solution: 'Ensure that the file extension is .csv'
        },
        {
            error: 'Information Missing',
            cause: 'One or more required columns information is missing in rows',
            solution: 'Be sure all the required columns are filled with information in each row created for a location.'
        },
        {
            error: 'Unknown column name',
            cause: 'There are additional/fewer columns detected in the uploaded file.',
            solution: 'Be sure that no columns are added/deleted, or moved within the file.'
        },
        {
            error: 'File must have header',
            cause: 'Uploaded file is missing the header row.',
            solution: 'Be sure to not temper with the header row values.'
        },
        {
            error: 'The file is too large to upload',
            cause: 'The file size has exceeded 20 MB or more than 1000 location entries.',
            solution: 'Split the file into parts to reduce the file size.'
        },
        {
            error: 'Character limit exceeded',
            cause: 'The file contains information that violates the character count limit.',
            solution: ['Make sure you adhere to the character limits specified in the ', <a href={columnReferencePath}><u>column reference</u></a>, '.']
        },
        {
            error: 'Duplication found',
            cause: 'The file contains entries that already exist in the system',
            solution: 'Resolve the duplication by removing the duplicate entry.'
        },
    ]

    return (
        <TableGridDiv>
            {/*  Table Header  */}
            <TableHeaderRow>
                {columns.map((column)=>(
                    <TableHeaderCell gridColumn={column.position}
                                     key={column.label}
                                     label={column.label}  />
                ))}
            </TableHeaderRow>
            {/*  Table Body  */}
            <TableBody className={classes.tableBody}>
                {resolveCommonErrors.map((requiredColumn, index) => {
                    const {error, cause, solution} = requiredColumn
                    return(
                        <TableBodyRow isOpen={true} key={index} className={classes.tableRow}>
                            <TableBodyCell gridColumn={columns[0].position} className={classes.tableCell} fontSize={'14px'}>
                                <b>{error}</b>
                            </TableBodyCell>
                            <TableBodyCell gridColumn={columns[1].position} className={classes.tableCell} fontSize={'14px'}>
                                {cause}
                            </TableBodyCell><TableBodyCell gridColumn={columns[2].position} className={classes.tableCell} fontSize={'14px'}>
                                {solution}
                            </TableBodyCell>
                        </TableBodyRow>
                    )})}
            </TableBody>
        </TableGridDiv>
    )
}

export default CommonErrorsTable

const useStyles = makeStyles({
    tableCell: {
        whiteSpace: 'normal',
        overflow: 'visible',
        textOverflow: 'clip'
    },
    tableBody: {
        maxHeight: '130px'
    },
    tableRow: {
        height: '130px'
    }
})